import {
  getConsents,
  getSalesPointConfiguration,
  setTenant,
} from '@/features/configuration/configurationActions';
import type {
  ConsentsResponseDTO,
  SalesPointConfigurationResponseDTO,
} from '@/types/dto/agent';
import type { TenantOption } from '@/types/tenant';
import { getInitialTenant } from '@/utils/tenant';
import { createReducer } from '@reduxjs/toolkit';

type ConfigurationState = {
  tenant: TenantOption;
  consents?: ConsentsResponseDTO;
  salesPointConfiguration?: SalesPointConfigurationResponseDTO;
};

const initialState: ConfigurationState = {
  tenant: getInitialTenant(),
};

export const configurationReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setTenant.fulfilled, (state, action) => {
      state.tenant = action.payload;
    })
    .addCase(getSalesPointConfiguration.fulfilled, (state, action) => {
      state.salesPointConfiguration = action.payload;
    })
    .addCase(getConsents.fulfilled, (state, action) => {
      state.consents = action.payload;
    });
});
